module.exports = __webpack_public_path__ + "public/images/slider/speaker-1.0ab29dd5734057a1270d6b0c6addc402.webp";